function ctrl($scope, $rootScope, Global, $location, $http, $state, $window, timeFormat, ngDialog) {
    $scope.global = Global;
    let model = this;

    //////////////////////////
    //// CLIENT AND ZONES ////
    //////////////////////////
    this.changeClient = (client) => {
        // if the client is different from the current one
        if ($scope.global.user.settings_global.current.client !== client) {
            $http({
                method: 'POST',
                url: api+'/api/users/change_client',
                data: {
                    client : client
                }
            })
            .success(function (result) {
                delete $window.sessionStorage.token;
                $window.sessionStorage.token = result.token;
                $scope.global.user.settings_global.current = result.current;
                if ($state.current.url === '/live') {
                // for now if we're on the live page already, lets do a refresh
                   $window.location.reload();
                } else {
                // else we just change page
                    if ($location.$$search.hasOwnProperty('start') && $location.$$search.hasOwnProperty('end')) {
                        // copy the time and strip out any other vars when clicking sidebar items
                        let time = angular.copy({ start: $location.$$search.start, end: $location.$$search.end });
                        $location.path('/live').search(time);
                    } else {
                        $location.path('/live').search({});
                    }
                }
            })
            .error(function () {
                alert('"'+$scope.global.user.email+'" does not have access to the "'+client+'" Client');
            })
        }
    }

    //////////////////////////////
    /////////// SEARCH ///////////
    //////////////////////////////
    // on load check state to see if search needs to be set to manual or not
    if (typeof $state.current.data.manualSearch !== 'undefined') { // check to see if it exists in state
        if ($state.current.data.manualSearch === true) { // make sure the value is set to true
            // set model to true
            model.manualSearch = true;
            $scope.main.setManualSearch(model.manualSearch);
        }
    }
    $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
        // set parent scope searchmode to false if this state's is true
        if (model.manualSearch) {
            $scope.main.setManualSearch(false);
            // on state change disable the manual search if it exists
            model.manualSearch = false;
        }
        // run settign function on main controller
        // then proceed to check if this route needs it turned on
        if (!toState.hasOwnProperty('data')) { return }
        if (!toState.data.manualSearch) { return } // make sure the value is set to true if it even exists
        model.manualSearch = true;
        $scope.main.setManualSearch(model.manualSearch);
    })

    ////////////////////////////
    //// ACCOUNT MANAGEMENT //// (LOGGED IN USER)
    ////////////////////////////
    $scope.openSettingsModal = function () {
        let model = this;
        // set error to false
        model.error = false;
        // set local user variable as refrence for what the user looked like before modal opening
        let user = angular.copy($scope.global.user);
        // set the user object for the modal
        model.user = angular.copy($scope.global.user);
        ///////////
        // TAB 1 //
        ///////////////////
        // EMAIL EDITING //
        ///////////////////
        // set email edit mode to false by default
        model.emailEditMode = false;
        let emailChanged = false;
        model.emailEditModeToggle = function (form) {
            if (model.emailEditMode) {
                model.emailEditMode = false;
                // set emailChanged according to if email eas actually changed
                if ((form.$valid) && (model.user.email !== user.email)) {
                    model.error = false; // clear any error that may have existed upon trying new change
                    emailChanged = true;
                    // send save signal here
                    $http({
                        method: 'POST',
                        url: api+'/api/users/updateemail',
                        data: {
                            email: user.email,
                            newEmail: model.user.email
                        }
                    })
                    .success(function (token) {
                        // delete old token
                        delete $window.sessionStorage.token;
                        // set new token
                        $window.sessionStorage.token = token;
                        // then set original user email to this new value
                        user.email = angular.copy(model.user.email);
                        $scope.global.user.email = model.user.email;
                    })
                    .error(function (data) {
                        model.error = data.message; // set error message
                        model.user.email = user.email;
                    });
                } else {
                    emailChanged = false;
                }
            } else {
                model.emailEditMode = true;
            }
        }
        model.emailEditModeCancel = function () {
            // just reset the model.email back to the original / since last save
            model.email = user.email;
            // turn off edit mode
            model.emailEditMode = false;
            model.user.email = user.email;
        }
        //////////////////////
        // PASSWORD EDITING //
        //////////////////////
        model.submitPassword = function (form) {
            // check to make sure the form is completely valid
            if ((form.$valid) && (model.user.password) && (model.user.cpassword === model.user.password) && (model.user.password !== '')) {
                let r = confirm('Are you sure? You will be logged out.');
                if (r == true) {
                    $http({
                        method: 'POST',
                        url: api+'/api/users/updatepass',
                        data: {
                            newPass: model.user.password
                        }
                    })
                    .success(function (token) {
                        $scope.logout();
                    })
                    .error(function (data) {
                        model.error = data.message; // set error message
                        model.user.email = user.email;
                    });
                } else {
                    model.user.password = '';
                    model.user.cpassword = '';
                }
            }
        };
        ///////////
        // TAB 2 //
        ////////////////
        // TWO FACTOR //
        ////////////////
        model.twoFactorSwitch = false;
        model.otpurl = '';
        model.otpkey = '';
        model.twoFactorMode = 'disabled';
        // if exists in the user object set mode to enabled
        if (user.two_step_auth_set) {
            model.twoFactorMode = 'enabled';
            model.twoFactorSwitch = true;
        }
        model.toggleTwoFactorConfig = function (active) {
            model.error = false; // kill any error messages
            // if mode is disabled and action is on, set to temporary 'setup' mode
            if (active && (model.twoFactorMode === 'disabled')) {
                model.twoFactorMode = 'setup';
                $http({
                    method: 'GET',
                    url: api+'/api/users/generateotp'
                })
                .success(function (key) {
                    model.otpkey = key.ascii;
                    model.otpurl = key.otpauth_url
                })
            } else if (!active) {
                // else if not active
                if (model.twoFactorMode === 'setup') {
                    // if still setting up change mode to disabled
                    model.twoFactorMode = 'disabled';
                } else {
                    // else remove the user's key and mark disabled
                    $http({
                        method: 'POST',
                        url: api+'/api/users/setotp',
                        data: {
                            key: false
                        }
                    })
                    .success(function (token) {
                        // get token back and reassign it
                        model.twoFactorMode = 'disabled';
                        // update user
                        model.user.two_step_auth_set = null;
                        $scope.global.user.two_step_auth_set = null;
                    })
                }
            }
        }
        model.twoFactorSubmit = function (form) {
            model.error = false; // kill any error messages
            if (form.$valid) {
                $http({
                    method: 'POST',
                    url: api+'/api/users/setotp',
                    data: {
                        passcode: form.verify.$modelValue,
                        key: model.otpkey
                    }
                })
                .success(function () {
                    // update user objects
                    model.user.two_step_auth_set = true;
                    $scope.global.user.two_step_auth_set = true;
                })
                .error(function (data) {
                    model.error = data.message; // set error message
                });
            }
        }
        ///////////
        // TAB 3 //
        /////////////
        // REPORTS //
        /////////////
        // default reports
        let defaultAvailableReportsList = function () {
            return [{
                title: 'IOC Events',
                single: true,
                type: 'iocevents'
            }]
        }
        let defaultReportSettings = function () {
            return {
                hour: null,
                day: null
            }
        }
        // set default report settings to null
        model.reportSettings = defaultReportSettings();
        // edit mode is set to false by default
        model.reportsEditMode = false;
        // helper function used to filter the AVAILABLE list depending on if the report is a 'single' or not
        model.checkForOneReport = function (item) {
            let result = true; // hide items by default
            for (let c = 0, len = model.user.settings_global.reports.length; c < len; c++) {
                if (item.single && (model.user.settings_global.reports[c].type === item.type)) {
                    result = false;
                }
            }
            return result;
        }
        // populate the available reports from the defaultReports function
        model.available = defaultAvailableReportsList();
        // Sortable config for current reports list
        model.currentConfig = {
            group: 'reportsGroup',
            animation: 150,
            sort: false,
            onAdd: function (evt) {
                // model.reportSettings = angular.copy(defaultReportSettings()); // because its a new add, lets add default settings to the form's model
                // evt.model.settings = angular.copy(model.reportSettings); // assign settings to the evt object before sending it to the edit function
                model.editReport(evt.newIndex); // run edit function on new report
                model.available = angular.copy(defaultAvailableReportsList()); // update available reports
            },
            onRemove: function (evt) {
                model.available = angular.copy(defaultAvailableReportsList()); // update available reports
                // close edit pane and remove incomplete form (if removing current open one)
            },
        };

        model.editReport = function (index) {
            // turn on edit mode
            model.reportsEditMode = true;
            // check to see if the report has settings or not
            if (model.user.settings_global.reports[index].hasOwnProperty('settings')) {
                // replace our model with that
                model.reportSettings = angular.copy(model.user.settings_global.reports[index].settings);
                // delete the settings in list for now
                delete model.user.settings_global.reports[index].settings;
            } else {
                // add default fields to our form
                model.reportSettings = angular.copy(defaultReportSettings());
            }
        }
        model.saveReportEdit = function (form) {
            if (!form.$valid) { return } // return if form is not valid
            let fields = angular.copy(model.reportSettings);
            for (let i = 0, len = model.user.settings_global.reports.length; i < len; i++) {
                if (!model.user.settings_global.reports[i].hasOwnProperty('settings')) {
                    model.user.settings_global.reports[i].settings = fields; // assign the fields to the reports settings
                    continue; // end loop
                }
            }
            let reports = angular.copy(model.user.settings_global.reports);
            $http({
                method: 'POST',
                url: api+'/api/users/reports',
                data: {
                    reports: reports
                }
            })
            .success(function (token) {
                // reset form
                if (form) {
                    form.$setPristine();
                    form.$setUntouched();
                }
                // delete old token
                delete $window.sessionStorage.token;
                // set new token
                $window.sessionStorage.token = token;
                // assingn the new report settings to the static user obj
                user.settings_global.reports = reports;
                $scope.global.user.settings_global.reports = reports;
                // add settings obj to the selected report
                model.reportsEditMode = false;
                model.reportSettings = defaultReportSettings();
            })
        }
        model.deleteReport = function (index) {
            let c = confirm("Are you sure you want to delete this report?");
            if (c) {
                // now remove the item and save
                model.user.settings_global.reports.splice(index, 1); // remove item
                let reports = angular.copy(model.user.settings_global.reports);
                $http({
                    method: 'POST',
                    url: api+'/api/users/reports',
                    data: {
                        reports: reports
                    }
                })
                .success(function (token) {
                    // delete old token
                    delete $window.sessionStorage.token;
                    // set new token
                    $window.sessionStorage.token = token;
                    // assingn the new report settings to the static user obj
                    user.settings_global.reports = reports;
                    $scope.global.user.settings_global.reports = reports;
                    // add settings obj to the selected report
                    model.reportsEditMode = false;
                    model.reportSettings = defaultReportSettings();
                })
            }
        }
        model.closeReportEdit = function (form) {
            // reset form
            if (form) {
                form.$setPristine();
                form.$setUntouched();
            }
            // crude check to see if the settings are default
            let isdefault = false;
            for (let i in model.reportSettings) {
                if (!model.reportSettings[i]) {
                    isdefault = true;
                }
            }
            // find the report with no assigned settings and remove it from the list
            for (let i = 0, len = model.user.settings_global.reports.length; i < len; i++) {
                if (!model.user.settings_global.reports[i].hasOwnProperty('settings')) {
                    if (isdefault) { // remove item
                        model.user.settings_global.reports.splice(i, 1); // remove item
                    }
                    continue; // break loop
                }
            }

            // return edit mode to false
            model.reportsEditMode = false;
            model.available = angular.copy(defaultAvailableReportsList()); // update available reports
        }
        ///////////
        // TAB 4 //
        ////////////
        // ALERTS //
        ////////////
        model.isActive = function () {
            let result = false;
            if ((model.user.settings_global.alerts.lvl4) || (model.user.settings_global.alerts.lvl3) || (model.user.settings_global.alerts.lvl2) || (model.user.settings_global.alerts.lvl1)){
                result = true;
            }
            if ((user.settings_global.stealth) && (model.user.settings_global.alerts.stealth)){
                result = true;
            }
            return result;
        }
        model.alertChange = function () {
            let result = false;
            if ((model.user.settings_global.alerts.frequency !== user.settings_global.alerts.frequency) || (!model.user.settings_global.alerts.frequency)) {
                result = true;
            }
            return result;
        }
        model.alertSubmit = function (form) {
            model.error = false; // kill any error messages
            if ((!model.isActive()) || form.$valid) {
                // else remove the user's key and mark disabled
                $http({
                    method: 'POST',
                    url: api+'/api/users/alerts',
                    data: {
                        alerts: angular.copy(model.user.settings_global.alerts)
                    }
                })
                .success(function (token) {
                    // delete old token
                    delete $window.sessionStorage.token;
                    // set new token
                    $window.sessionStorage.token = token;
                    // assingn the new report settings to the static user obj
                    user.settings_global.alerts = angular.copy(model.user.settings_global.alerts);
                })
            }
        }

        // modal config
        ngDialog.open({
            template: require('../../views/modals/usersettings.html'),
            plain: true,
            appendTo: ['.page-content', '.map-container'],
            scope: model,
            preCloseCallback: function () {
                // use the doneEdit function since it already checks for changes
                // model.doneEdit();
            }
        });
    }
    ////////////////////////////
    //// DATABASE SWITCHING ////
    ////////////////////////////


    ////////////////////////////
    //// OTHER HEADER STUFF ////
    ////////////////////////////
    $scope.logout = function () {
        ngDialog.close();
        delete $window.sessionStorage.token;
        $location.url('/login');
    }
    // this is being used for the home button right now
    $scope.go = function ( path ) {
        var search = {};
        if ($location.$$search.start && $location.$$search.end) {
            search.start = $location.$$search.start;
            search.end = $location.$$search.end;
        }
        if ((path === '/manage_users') || (path === '/manage_feeds')){
            $location.url(path);
        }else if (($window.location.pathname === '/live') && (path === '/')) { // reload inbound_ioc only if on home and logo is clicked
            $window.location.reload();
        } else {
            $window.location.assign('/live')
        }
    };
}

ctrl.$inject = ['$scope', '$rootScope', 'Global', '$location', '$http', '$state', '$window', 'timeFormat', 'ngDialog'];
module.exports = ctrl;


/** WEBPACK FOOTER **
 ** ./src/pages/controllers/main/header.js
 **/